var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,11 C7.962,11 5.5,8.538 5.5,5.5 C5.5,2.462 7.962,0 11,0 C14.038,0 16.5,2.462 16.5,5.5 C16.5,8.538 14.038,11 11,11 Z M11,9 C12.933,9 14.5,7.433 14.5,5.5 C14.5,3.567 12.933,2 11,2 C9.067,2 7.5,3.567 7.5,5.5 C7.5,7.433 9.067,9 11,9 Z M21.408,16.082 C21.584,16.463 21.707,17.012 21.814,17.741 C21.868,18.112 21.914,18.506 21.952,18.9 C21.965,19.037 21.976,19.165 21.986,19.28 C21.992,19.349 21.995,19.4 21.997,19.429 L22,19.5 C22,20.879 20.882,22 19.503,22 L2.497,22 C1.118,22 0,20.879 0,19.5 L0.003,19.429 C0.005,19.4 0.008,19.349 0.014,19.28 C0.024,19.165 0.035,19.037 0.048,18.9 C0.086,18.506 0.132,18.112 0.186,17.741 C0.293,17.012 0.416,16.463 0.592,16.082 C1.36,14.414 7.018,12 11,12 C14.982,12 20.64,14.414 21.408,16.082 Z M19.49,16.844 C19.35,16.722 19.15,16.574 18.902,16.415 C18.348,16.059 17.616,15.678 16.808,15.333 C14.869,14.506 12.792,14 11,14 C9.208,14 7.131,14.506 5.192,15.333 C4.384,15.678 3.652,16.059 3.098,16.415 C2.85,16.574 2.65,16.722 2.51,16.844 C2.458,16.89 2.418,16.929 2.392,16.958 C2.324,17.136 2.239,17.529 2.165,18.031 C2.116,18.366 2.074,18.729 2.039,19.092 C2.021,19.279 2.008,19.429 2.001,19.527 C2.015,19.79 2.233,20 2.497,20 L19.503,20 C19.767,20 19.985,19.79 19.999,19.527 C19.992,19.429 19.979,19.279 19.961,19.092 C19.926,18.729 19.884,18.366 19.835,18.031 C19.761,17.529 19.676,17.136 19.608,16.958 C19.582,16.929 19.542,16.89 19.49,16.844 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03-Company",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24x24/Mail_Message"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#0067DF",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersActive);
export default __webpack_public_path__ + "static/media/Users_Active.58348824e3b2847b598a175e88650895.svg";
export { ForwardRef as ReactComponent };